import * as React from "react";
import * as moment from "moment";
import { FaUserAlt, FaIdCard, FaTag, FaEnvelope, FaPhone, FaCalendarAlt, FaMapMarkedAlt, FaMapPin } from "react-icons/fa";
import { MdLocationCity } from "react-icons/md";

var getClassificationLabel = function getClassificationLabel(classification) {
  if (!classification) return {
    text: "Sin clasificación",
    color: "label-classification-default"
  };
  var c = classification.toLowerCase();
  if (c.includes("asegurado y contratante")) return {
    text: classification,
    color: "label-classification-blue"
  };
  if (c.includes("asegurado")) return {
    text: classification,
    color: "label-classification-green"
  };
  if (c.includes("contratante")) return {
    text: classification,
    color: "label-classification-orange"
  };
  if (c.includes("vip")) return {
    text: classification,
    color: "label-classification-vip"
  };
  if (c.includes("premium")) return {
    text: classification,
    color: "label-classification-premium"
  };
  return {
    text: classification,
    color: "label-classification-other"
  };
};

var getHeaderIcon = function getHeaderIcon(type) {
  if (type === "Users::NaturalPerson") return /*#__PURE__*/React.createElement(FaUserAlt, {
    className: "user-icon user-icon-natural"
  });
  if (type === "Users::LegalPerson") return /*#__PURE__*/React.createElement(MdLocationCity, {
    className: "user-icon user-icon-legal"
  });
  return /*#__PURE__*/React.createElement(FaUserAlt, {
    className: "user-icon user-icon-default"
  });
};

var getUserFullName = function getUserFullName(user) {
  if (user.full_name && user.full_name.trim() !== "") return user.full_name;
  return [user.name, user.middle_name, user.first_surname, user.second_surname].filter(Boolean).join(" ") || "-";
};

var ListUser = function ListUser(_ref) {
  var users = _ref.users,
      onSelectedUser = _ref.onSelectedUser,
      admin = _ref.admin;

  var formatDate = function formatDate(date) {
    if (!date) return "-";
    return moment(date).format("DD/MM/YYYY");
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "users-list-modern"
  }, users.map(function (user) {
    var _user$region, _user$comuna;

    var classificationLabel = getClassificationLabel(user.classification_text);
    return /*#__PURE__*/React.createElement("div", {
      key: user.id,
      className: "user-modern-card",
      onClick: function onClick() {
        return onSelectedUser(user);
      },
      style: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "user-classification-label user-classification-label-header ".concat(classificationLabel.color)
    }, classificationLabel.text), /*#__PURE__*/React.createElement("div", {
      className: "user-header-row"
    }, getHeaderIcon(user.type), /*#__PURE__*/React.createElement("span", {
      className: "user-id"
    }, "ID: ", user.id)), /*#__PURE__*/React.createElement("div", {
      className: "user-modern-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "user-row user-row-main"
    }, /*#__PURE__*/React.createElement(FaTag, {
      className: "user-row-icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "user-main-text"
    }, /*#__PURE__*/React.createElement("strong", null, getUserFullName(user)))), /*#__PURE__*/React.createElement("div", {
      className: "user-row"
    }, /*#__PURE__*/React.createElement(FaIdCard, {
      className: "user-row-icon"
    }), /*#__PURE__*/React.createElement("span", null, user.rut || "-")), /*#__PURE__*/React.createElement("div", {
      className: "user-row user-row-long"
    }, /*#__PURE__*/React.createElement(FaEnvelope, {
      className: "user-row-icon"
    }), /*#__PURE__*/React.createElement("span", null, user.email || "-"), user.emails && user.emails.length > 0 && user.emails.filter(function (e) {
      return !e.is_main && e.email !== user.email;
    }).length > 0 && /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'block',
        fontSize: '0.95em',
        color: '#2596be',
        marginTop: '2px'
      }
    }, /*#__PURE__*/React.createElement(FaEnvelope, {
      style: {
        marginRight: 4,
        fontSize: '0.95em',
        verticalAlign: 'middle'
      }
    }), user.emails.filter(function (e) {
      return !e.is_main && e.email !== user.email;
    })[0].email)), console.log("USER DATA:", user), /*#__PURE__*/React.createElement("div", {
      className: "user-row"
    }, /*#__PURE__*/React.createElement(FaPhone, {
      className: "user-row-icon"
    }), /*#__PURE__*/React.createElement("span", null, user.phone || "-", user.user_phones && user.user_phones.length > 0 && user.user_phones.map(function (phone, idx) {
      return /*#__PURE__*/React.createElement("span", {
        key: idx,
        style: {
          display: "block",
          marginLeft: "24px",
          color: '#2596be'
        }
      }, phone.phone, phone.observation && /*#__PURE__*/React.createElement("span", {
        style: {
          color: "#888",
          fontSize: "0.95em",
          marginLeft: "4px"
        }
      }, "(", phone.observation, ")"));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "user-row"
    }, /*#__PURE__*/React.createElement(FaMapMarkedAlt, {
      className: "user-row-icon"
    }), /*#__PURE__*/React.createElement("span", null, ((_user$region = user.region) === null || _user$region === void 0 ? void 0 : _user$region.name) || "-", " / ", ((_user$comuna = user.comuna) === null || _user$comuna === void 0 ? void 0 : _user$comuna.name) || "-")), /*#__PURE__*/React.createElement("div", {
      className: "user-row user-row-long"
    }, /*#__PURE__*/React.createElement(FaMapPin, {
      className: "user-row-icon"
    }), /*#__PURE__*/React.createElement("span", null, user.street || "-")), /*#__PURE__*/React.createElement("div", {
      className: "user-row"
    }, /*#__PURE__*/React.createElement(FaCalendarAlt, {
      className: "user-row-icon"
    }), /*#__PURE__*/React.createElement("span", null, "Creado: ", formatDate(user.created_at))), /*#__PURE__*/React.createElement("div", {
      className: "user-row"
    }, /*#__PURE__*/React.createElement(FaCalendarAlt, {
      className: "user-row-icon"
    }), /*#__PURE__*/React.createElement("span", null, "Actualizado: ", formatDate(user.updated_at)))), admin && /*#__PURE__*/React.createElement("div", {
      className: "user-modern-actions"
    }, /*#__PURE__*/React.createElement("button", {
      className: "btn btn-primary btn-modern-view",
      onClick: function onClick(e) {
        e.stopPropagation();
        window.open("/admin/users/".concat(user.id), "_blank");
      }
    }, "Ver"), /*#__PURE__*/React.createElement("button", {
      className: "btn btn-success btn-modern-edit",
      onClick: function onClick(e) {
        e.stopPropagation();
        window.open("/admin/users/".concat(user.id, "/edit"), "_blank");
      }
    }, "Editar")));
  }));
};

export default ListUser;